import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import {
  MdControlPoint,
  MdDelete,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import deleteitem from "../../../components/Images/deleteitem.svg";
import edititem from "../../../components/Images/edititem.svg";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import "./Translation.css";
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable'
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoClose } from "react-icons/io5";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";

function SubtitleLanguage(props) {
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [validationMessagename, setValidationMessagename] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);

  const [validationMessageshort_code, setValidationMessageshort_code] = useState("");
  const [isValidationHiddenshort_code, setIsValidationHiddenshort_code] = useState(true);
  const [withOutRefresh, setWithOutRefresh] = useState(false)

  const nameInputRef = useRef(null);
  const short_codeInputRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [reloading, setReLoading] = useState(false);
  const [getSubtitleLanuage, setSubtitleLanguage] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [itemToDeletevideolanguage, setItemToDeletevideolanguage] = useState(
    []
  );
  const [selectAll, setSelectAll] = useState(false);

  const [filter, setFilter] = useState("");
  const [modelClose, setModelClose] = useState(false);

  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const fetchDatavideolanguage = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/index`,
        { headers: headers }
      );
      setSubtitleLanguage(response?.data?.AllSubtitle);
      setFilteredData(response?.data?.AllSubtitle);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "Subtitle-language" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  };
  useEffect(async () => {
    fetchDatavideolanguage();
  }, [withOutRefresh]);
  const [editUser, setEditUser] = useState({
    name: "",
    short_code: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "name") {
      if (value.trim() !== "" && value.trim().length >= 3 && value.trim().length <= 100) {
        setValidationMessagename("");
        setIsValidationHiddenname(true);
      }
    }
    if (name === "short_code") {
      if (value.trim() !== "" && value.trim().length <= 8) {
        setValidationMessageshort_code("");
        setIsValidationHiddenshort_code(true);
      }
    }
  };

  const handleModalClose = () => {
    setEditUser({});
    setValidationMessagename("");
    setValidationMessageshort_code("");
    setIsValidationHiddenname(true);
    setIsValidationHiddenshort_code(true);
  };


  const inputCheck = async () => {
    let focusInputRef = null;
    if (editUser?.name === "") {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    } else if (editUser.name?.trim().length < 3) {
      setValidationMessagename("Name must be at least 3 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    } else if (editUser.name?.trim().length > 100) {
      setValidationMessagename("Name must not exceed 100 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }
    if (editUser?.short_code === "") {
      setValidationMessageshort_code("Short code cannot be empty.");
      setIsValidationHiddenshort_code(false);
      focusInputRef = short_codeInputRef;
    } else if (editUser.short_code?.trim().length > 8) {
      setValidationMessageshort_code("Short code must not exceed 8 characters.");
      setIsValidationHiddenshort_code(false);
      focusInputRef = short_codeInputRef;
    }

    if (focusInputRef) {
      focusInputRef?.current?.focus();
      return;
    }

    if (isValidationHiddenname && isValidationHiddenshort_code) {
      savelanguages();
    }
  };

  const savelanguages = async () => {
    const formData = {
      language: editUser?.name,
      short_code: editUser?.short_code,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    let firstApiStatus = false;
    let resultapi = null;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/store`,
        formData,
        { headers: headers }
      );

      if (response?.data?.status === true) {
        toast.success(response?.data?.message)
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }

  };
  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredData.length },
    ],
  });
  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDeletevideolanguage([...itemToDeletevideolanguage, row.id]);
        } else {
          setItemToDeletevideolanguage(
            itemToDeletevideolanguage.filter((id) => id !== row?.id)
          );
        }
      }
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDeletevideolanguage(allIds);
      } else {
        setItemToDeletevideolanguage([]);
      }
    },
    selected: itemToDeletevideolanguage,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input
          type="checkbox"
          checked={checked}
          ref={(input) => {
            if (input) input.indeterminate = false;
          }}
        />
      </div>
    ),
  };
  const userFormatter = (data, row) => {
    const displayName = data?.length > 15 ? `${data.slice(0, 15)}...` : data;
    return (
      <div className="d-flex flex-column align-items-start">
        <span>{displayName}</span>
        <span className="dateText"> {row?.upload_on}</span>
      </div>
    );
  };

  const shortCodeFormatter = (data) => {
    const displayCode = data?.length > 15 ? `${data.slice(0, 15)}...` : data;
    return <span>{displayCode}</span>;
  };
  const actionFormatter = (data, row) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <span>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </span>
        </span>
        <div className="editdropdown-menu">
          <Link to={`/edit-subtitlelanguage/${row?.id}`}>
            <IconEditFigma styled={{ width: "24px", height: "24px" }} />
            <span className="theme-text-color">
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>

          <div
            onClick={() => openModalvideolanguageSingleDelete(row?.id)}
            className="commonActionPadding"
          >
            <IconDeleteFigma styled={{ width: "24px", height: "24px" }} />
            <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
          </div>
        </div>
      </div>
    );
  };
  const exportHeaders = [
    { label: "ID", key: "id" },
    { label: "LANGUAGE", key: "language" },
    { label: "SHORT-CODE", key: "short_code" },
    { label: "UPLOAD-ON", key: "upload_on" },
  ];
  const conditionalGeneratePDF = async (get) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    doc.text("LANGUAGE SUBTITLE LIST ", 10, 10);
    const columns = ["Index", "ID", "LANGUAGE", "SHORT-CODE", "UPLOAD-ON"];
    const allDataPDF = getSubtitleLanuage.map((item, index) => [
      index + 1,
      item?.id,
      item?.language,
      item?.short_code,
      item?.upload_on,
    ]);
    const filterPDF = filteredData.map((item, index) => [
      index + 1,
      item?.id,
      item?.language,
      item?.short_code,
      item?.upload_on,
    ]);

    doc.autoTable({
      startY: 20,
      head: [columns],
      body: get == 1 ? allDataPDF : filterPDF,
    });
    doc.save("LANGUAGE-SUBTITLE-LIST.pdf");
  };
  const generateXLSX = async (get) => {
    const XLSX = await import("xlsx");
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(
        get === 1 ? getSubtitleLanuage : filteredData
      );
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, "LANGUAGE-SUBTITLE-LIST.xlsx");
  };
  const handleFilterChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    const filteredResults = getSubtitleLanuage?.filter((item) =>
      ["language", "short_code", "upload_on"].some(
        (property) =>
          typeof item[property] === "string" &&
          item[property].toLowerCase().includes(searchTerm)
      )
    );
    setFilteredData(filteredResults);
  };
  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDeletevideolanguage(
      selectAll ? [] : filteredData?.map((item) => item?.id)
    );
  };
  const handleClear = () => {
    fetchDatavideolanguage();
    setFilter("");
  };
  const openModalvideolanguageSingleDelete = (id) => {
    setItemToDeletevideolanguage([id]);
    setModelClose(true);
  };
  const closeModalvideolanguage = () => {
    setModelClose(!modelClose);
    setItemToDeletevideolanguage([]);
    setSelectAll(false);
  };
  const handleDeletevideolanguageMultiDelete = () => {
    setModelClose(true);
  };
  const handleDeletedata = () => {
    closeModalvideolanguage();
    if (itemToDeletevideolanguage) {
      videosdeleteOperationvideolanguage();
    }
  };
  const videosdeleteOperationvideolanguage = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/multi-delete`,
        {
          headers: headers,
          data: { id: [...itemToDeletevideolanguage] }
        }
      );
      const result = response?.data;
      if (result?.status === true) {
        toast.success(result?.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);

      }
    } catch (error) {
      console.error(error);
      var errorMessage = error?.response?.data?.message;
      toast.error(errorMessage);
    }
  };
  // const reloadAction = () => {
  //   setWithOutRefresh(prev => !prev)
  // }

  const reloadAction = async () => {
    setReLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/subtitles/index`,
        { headers: headers }
      );
      const subtitles = response?.data?.AllSubtitle || [];
      setSubtitleLanguage(subtitles);
      setFilteredData(subtitles);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setReLoading(false);
    }
  };



  const columns = [
    {
      dataField: "language",
      text: "Language",
      formatter: userFormatter,
    },
    {
      dataField: "short_code",
      text: "Short Code",
      formatter: shortCodeFormatter,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: actionFormatter,
    },
  ];
  return (
    <>
      <div
        className={`modal  packageModel ${modelClose ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: modelClose ? "block" : "none",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header theme-border-bottom-secondary">
              <MessageBox text={"Confirm Deletion"} classname="modal-title theme-text-color admin-modal-title fw-bold" />
              <button type="button" id="closeModelIcon" className='bg-transparent theme-text-color' onClick={closeModalvideolanguage} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
            </div>
            <div className="modal-body">
              {itemToDeletevideolanguage.length === 1 ? (
                <p>Are you sure you want to delete the selected item ?</p>
              ) : (
                <p>Are you sure you want to delete the selected items ?</p>
              )}
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModalvideolanguage}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeletedata}
              >
                Yes
              </button>
            </div> */}

            <div className="modal-footer gap-3 border-0">
              <>
                <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={closeModalvideolanguage} id="closeModal"><MessageBox text="Cancel" /> </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn warningColorBg theme-button-text-color d-inline-flex rounded-3  py-2 px-3"
                  onClick={handleDeletedata}
                >
                  Delete
                </button>
              </>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addlanguage"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {labelDisplay?.[2]?.title}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                <AdminCustomInput
                  type="text"
                  name="name"
                  value={editUser?.name}
                  onChange={handleInput}
                  placeHolder="Enter language name"
                  ref={nameInputRef}
                  error={validationMessagename}
                />
              </div>

              <div className="mt-2">
                <MessageLabel text={labelDisplay?.[7]?.title} className="mandatorySimple" />
                <AdminCustomInput
                  type="text"
                  name="short_code"
                  value={editUser?.short_code}
                  onChange={handleInput}
                  placeHolder="Enter short code"
                  ref={short_codeInputRef}
                  error={validationMessageshort_code}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary ml-3 "
                onClick={inputCheck}
              >
                {labelDisplay?.[5]?.title}
              </button>
            </div>
          </div>
        </div>
      </div>
      <section className="section container-fluid pt-3">
        <div id="content-page" className="content-page">
          <div className="row  admin-section-title">
            <div className="col-md-8">
              <h4 className="admin-title mb-0 theme-text-color text-md-start"> <MessageBox text={labelDisplay?.[0]?.title} classname="theme-text-color" /> <span className="admin-sub-title theme-text-color ms-2 ">( {getSubtitleLanuage?.length} <MessageBox text='results found' classname="theme-text-color" />   )</span> </h4>
            </div>
            <div className="col-md-4 mt-3 mt-md-0" align="right">
              {itemToDeletevideolanguage?.length > 0 && (
                <button
                  className="btn warningColorBg theme-button-text-color d-inline-flex  fw-bold mb-3"
                  onClick={handleDeletevideolanguageMultiDelete}
                >
                  <MdDelete className="exportIcon " />
                  Delete
                </button>
              )}
              <button
                type="button"
                className="admin-title ms-3 rounded-2 d-inline-flex align-items-center button-bg-color theme-button-text-color  text-decoration-hover  py-2 px-3"
                id="navigationLinkForAddPage"
                data-bs-toggle="modal"
                data-bs-target="#addlanguage"
              >
                <MdControlPoint className="me-2 exportIcon " style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text " text={labelDisplay?.[1]?.title} />
              </button>
            </div>
          </div>
          <div className="iq-card mt-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
              <div className="filterContainer">
                <input
                  type="text"
                  placeholder="Search"
                  className="filter form-control "
                  value={filter}
                  onChange={handleFilterChange}
                />
                {filter.length > 0 && (
                  <button
                    type="button"
                    className="closeBtn"
                    onClick={handleClear}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
              </div>
              <div className="btn-group">
                <button id="reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                </button>
                <div className="dropdown d-block ">
                  <button
                    className="btn btn-success dropdown-toggle d-flex"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="fw-bolder">Export All</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" />
                  </button>
                  <ul
                    className="dropdown-menu theme-text-color cursor-pointer"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li className="dropdown-item">
                      <CSVLink
                        headers={exportHeaders}
                        data={getSubtitleLanuage}
                        className=" d-block"
                        filename="LANGUAGE-SUBTITLE-LIST.csv"
                      >
                        CSV
                      </CSVLink>
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => {
                        conditionalGeneratePDF(1);
                      }}
                    >
                      PDF
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => {
                        generateXLSX(1);
                      }}
                    >
                      XLSX
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bootstrapTable">
              {reloading && (
                <div style={{
                  position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.6)',
                  display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10,
                }}><Defaultloadinggif />
                </div>
              )}
              <BootstrapTable
                keyField="id"
                columns={columns}
                data={filteredData}
                pagination={pagination}
                className="no-border-table"
                noDataIndication={
                  <div className="noRecord">
                    {loading ? (
                      <NoRecordTable result={filteredData?.length} loader={true} />
                    ) : (
                      filteredData?.length <= 0 && (
                        <p>No Subtitle Languages Available.!</p>
                      )
                    )}
                  </div>
                }
                hover
                headerClasses="custom-header"
                selectRow={selectRow}
                selectAll={selectAll}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default SubtitleLanguage;
